module.exports = __webpack_public_path__ + "img/ico_instagram.4da87545.png";